import React , { useState,useEffect }from 'react'
import { Button,  Form, message, Modal,DatePicker,Input,Radio,Space } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import {api_candidates_edit_intvtime} from '../../api';
import moment from 'moment';
// import 'moment/locale/zh-cn';
// // 设置 moment 语言为中文
// moment.locale('zh-cn');

const screenHeight = document.body.clientHeight;

const App =(props)=>{
    const {showModal, rowInfo, closeModal, refreshlist} = props;
    console.log('1111111111111111111111111111111111111-', rowInfo)
    const [form] = Form.useForm();
    const [loading,setLoading] = useState(false);
    const [showETime, setShowETime] = useState(false);

    useEffect(() => {
      if(showModal && rowInfo.interview_time)
        form.setFieldValue("old_interview_time", rowInfo.interview_time);
      else
        form.resetFields();
    }, [showModal]);

    const now = moment();
    // const tomorrow = now.clone().add(1, 'day').startOf('day');
    const disabledTime = (current) => {
      if (!current || current.isSame(now, 'day')) {
        return {
          disabledHours: () => {
            const hours = [];
            for (let i = 0; i < now.hours(); i++) {
              hours.push(i);
            }
            return hours;
          },
          disabledMinutes: (selectedHour) => {
            if (selectedHour==-1 || selectedHour === now.hours()) {
              const minutes = [];
              for (let i = 0; i < now.minutes(); i++) {
                minutes.push(i);
              }
              return minutes;
            }
            return [];
          },
          disabledSeconds: () => [],
        };
      }
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => [],
      };
    }; 
  
    const disabledDate = (current) => {
        return current && current < moment().startOf('day');
    };

      
    const onChangeHaveTime = (e) => {
      var data = e.target.value
      console.log(data)
      if(data=='1')
        setShowETime(true);
      else
        setShowETime(false);
    };

  
    const onFinish = async(value)=>{
      console.log(value);
      // if(value.have_time=='1' && !value.expected_time){
      //   message.warn("请输入期望面试时间");
      //   return false;
      // }

      const p = {candidate_id:rowInfo.candidate_id, try:value.try, expected_time:"" };
      if(value.expected_time){
        const expected_time = moment(value.expected_time).format('YYYY-MM-DD HH:mm');
        if(expected_time == rowInfo.interview_time){
          message.warn("期望面试时间不能与原定面试时间相同");
          return false;
        }
        p.expected_time = expected_time;
      }
      console.log(p);

      setLoading(true);
      try {
        api_candidates_edit_intvtime(p).then((res) => {
          setLoading(false);
          console.log('api_candidates_edit_intvtime-res-----------------', res);
          if (res.data.code == 9) {
            message.success("改期成功");
            closeModal();
            refreshlist();
          }else{
            message.error(res.data.msg);
          }
        });
        } catch (error) {
          message.error("异常错误");
          setLoading(false);
          return false;
        }
      }

  return (
    <Modal 
        key="orderinfo"
        title={"面试改期—"+rowInfo.name}
        open={showModal}
        width={600}
        bodyStyle={{maxHeight:screenHeight*0.8,overflowY:"scroll"}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeModal}>
        取消
        </Button>,
        <Button type="primary" loading={loading} style={{ marginLeft:'20px',backgroundColor:"rgb(24,188,156)"}} onClick={()=>{form.submit()}}>
        确认
        </Button>] }
        onCancel={closeModal}>
          <Form form={form}
            className='loginForm reginfo'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            layout="horizontal"
            // autoComplete="off"
            labelAlign="left"
            labelCol={{span:8}}
            // style={{fontSize:12}}
            size="small"
            initialValues={{
              try:'0',
              have_time:'0', 
            }}
        >
            <Form.Item
                label="原定面试时间"
                name="old_interview_time"
            >
            <Input disabled bordered={false} />
            </Form.Item>
            <Form.Item
                label="改期类型"
                name="try"
                extra={<div style={{color:'green',fontSize:'12px',lineHeight: '20px',paddingTop:10,width:"100%",textAlign:"left"}}>*尝试改期:在候选人同意前，当前安排仍为有效安排。
                <br/>*取消改期:确认取消当前的面试安排寻求其他时间安排面试的可能，但需要与候选人磋商。</div>}
                >
              <Radio.Group style={{width:"80%"}} >
                <Space size={10}>
                <Radio value={"1"}>尝试改期</Radio>
                <Radio value={"0"}>取消改期</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item
                label="是否选定面试时间"
                name="have_time"
            >
              <Radio.Group style={{width:"80%"}} onChange={onChangeHaveTime} >
                <Space size={10}>
                <Radio value={"1"}>是</Radio>
                <Radio value={"0"}>否</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item
                label="期望面试时间"
                name="expected_time"
                rules={[
                  {required: showETime?true:false, message: '请输入期望面试时间',},
                ]}
                style={{display:showETime?"":"none"}}
            >
              <DatePicker 
                showTime={{ format: 'HH:mm' }} 
                format="YYYY-MM-DD HH:mm" 
                placeholder='请选择时间' 
                disabledDate={disabledDate}
                disabledTime={disabledTime}
              />
            </Form.Item>


        </Form>
        </Modal>
  )
}
export default App
